module.exports = __webpack_public_path__ + "img/6.322275b5.png";